import React from 'react'

import {
  Box,
  DisplayPosition,
  Display,
  AlignItems,
  JustifyContent,
  ZIndex,
  Icon,
  Color,
} from '@gousto-internal/citrus-react'

type ScrollArrowProps = {
  direction: 'left' | 'right'
  onClick: () => void
}

export const ScrollArrow = ({ direction, onClick }: ScrollArrowProps) => (
  <Box
    position={DisplayPosition.Absolute}
    display={Display.Flex}
    alignItems={AlignItems.Center}
    justifyContent={direction === 'left' ? JustifyContent.FlexStart : JustifyContent.FlexEnd}
    width="34px"
    zIndex={ZIndex.Mask}
    height="100%"
    left={direction === 'left' ? '-5px' : undefined}
    right={direction === 'right' ? '-5px' : undefined}
    top="0"
    bottom="0"
    style={{
      background:
        direction === 'left'
          ? 'linear-gradient(to right, rgba(255,255,255,1) 0%, rgba(255,255,255,0.96) 46%, rgba(255,255,255,0.72) 74%, rgba(255,255,255,0) 100%)'
          : 'linear-gradient(to left, rgba(255,255,255,1) 0%, rgba(255,255,255,0.96) 46%, rgba(255,255,255,0.72) 74%, rgba(255,255,255,0) 100%)',
      cursor: 'pointer',
    }}
    onClick={onClick}
  >
    <Icon color={Color.NeutralGrey_800} name={`chevron_${direction}`} size={8} />
  </Box>
)
